import { render, staticRenderFns } from "./CalculationMenu.vue?vue&type=template&id=e60b4ab4&scoped=true&"
import script from "./CalculationMenu.vue?vue&type=script&lang=ts&"
export * from "./CalculationMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60b4ab4",
  null
  
)

export default component.exports